module.exports = {
  MANAGE_ACCOUNT_FORMS: "https://learn.sessionboard.com/en/knowledge-base",
  MANAGE_ACCOUNT_USERS: "https://learn.sessionboard.com/en/knowledge-base",
  FORM_MANAGERS: "https://learn.sessionboard.com/en/knowledge-base",
  PORTAL_DOCUMENT_REQUESTS: "https://learn.sessionboard.com/en/knowledge-base"
};
